var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeclined = function SvgDeclined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L16 8M16 4L20 8",
    stroke: "white",
    strokeWidth: 0.923077,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5559 14.548L15.1009 15.028C15.1009 15.028 14.0179 16.167 11.0629 13.056C8.10786 9.94505 9.19086 8.80605 9.19086 8.80605L9.47786 8.50305C10.1839 7.75905 10.2509 6.56505 9.63386 5.69305L8.37386 3.91005C7.60986 2.83005 6.13486 2.68805 5.25986 3.60905L3.69086 5.26005C3.25786 5.71705 2.96786 6.30805 3.00286 6.96505C3.09286 8.64505 3.81086 12.258 7.81486 16.475C12.0619 20.945 16.0469 21.123 17.6759 20.962C18.1919 20.912 18.6399 20.633 19.0009 20.253L20.4209 18.757C21.3809 17.747 21.1109 16.017 19.8829 15.311L17.9729 14.211C17.1669 13.748 16.1859 13.884 15.5559 14.547V14.548Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeclined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "declined.be7c9704252bac75e885110d74c4a31c.svg";